<template>
    <ModalContainer>
        <div class="relative bg-white rounded-lg shadow p-4">
            <div class="flex items-start justify-between p-4 border-b rounded-t">
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                    AR Content Setting
                </h3>
                <button type="button"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center" @click="close">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <!-- Modal body -->
            <div class="p-6 space-y-6">
                <div class="mb-3">
                    <SelectGroup class="mb-2" label="Type" v-model="type" :options="getArContentTypes()" />
                    <div v-if="type === 'customContent'" style="width: 90vw;">
                        <TextEditorGroup label="Description" v-model="value" :mediaHandler="mediaHandler" />
                    </div>
                    <div v-else-if="type === 'externalUrl'">
                        <InputGroup class="mb-2" label="URL" v-model="value" />
                        <div class="mb-2">
                            <input name="passUserName" type="checkbox" id="passUserName"
                                v-model="config.passUserName" :value="true"
                                class="mr-2 text-secondary focus:ring-secondary" />
                            <label class="mr-2" for="passUserName">Pass User's Name</label>
                        </div>
                        <div class="mb-2">
                            <input name="passUserId" type="checkbox" id="passUserId"
                                v-model="config.passUserId" :value="true"
                                class="mr-2 text-secondary focus:ring-secondary" />
                            <label class="mr-2" for="passUserId">Pass User's ID</label>
                        </div>
                        <div class="mb-2">
                            <input name="storeCustomData" type="checkbox" id="storeCustomData"
                                v-model="config.storeCustomData" :value="true"
                                class="mr-2 text-secondary focus:ring-secondary" />
                            <label class="mr-2" for="storeCustomData">Store Custom Data</label>
                        </div>
                        <ButtonPrimary @click="clearEventRecord" v-if="config.storeCustomData && arImageTarget._id">Clear Record</ButtonPrimary>
                    </div>
                    <div v-else-if="type === 'iot'">
                        <InputGroup class="mb-2" label="Wireless ID" v-model="config.wirelessId" />
                        <InputGroup class="mb-2" label="Wireless Password" v-model="config.wirelessPassword" />
                        <InputGroup label="URL" v-model="value" />
                    </div>
                </div>
            </div>
        </div>
    </ModalContainer>
</template>
<script>
import ModalContainer from '../../../components/modal/ModalContainer';
export default {
    props: {
        action: {},
        closeAction: {},
        mediaHandler: {},
        arContent: {},
        arImageTarget: {},
    },

    components: {
        ModalContainer,
    },

    data() {
        return {
            type: this.arContent.type || 'details',
            value: this.arContent.value || '',
            config: this.arContent.config || {},
        };
    },

    methods: {
        close() {
            this.action({
                type: this.type,
                value: this.value,
                config: this.config,
            });
            this.closeAction();
        },

        async clearEventRecord() {
            const action = async () => {
                await this.$root.organizer.clearRecord(this.arImageTarget._id);
            };

            this.$root.showConfirm('Confirm clear the record?', action);
        },
    },

    watch: {
        type() {
            this.value = '';
            this.config = {};
        },  
    }
}
</script>